import { __assign, __awaiter, __generator } from "tslib";
var BASE_URL = '/_serverless/polls-client/v1';
var PollsService = /** @class */ (function () {
    function PollsService(instance, getHttpClientPromise) {
        var _this = this;
        this.getHttpClientPromise = getHttpClientPromise;
        this.fetchData = function (response) { var _a; return ((_a = response.data) === null || _a === void 0 ? void 0 : _a.question) || response.data; };
        this.fetchPoll = function (pollId) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.getHttpClientPromise()];
                    case 1: return [2 /*return*/, (_a = (_b.sent())) === null || _a === void 0 ? void 0 : _a.get("/questions/".concat(pollId), this.requestOptions).then(function (response) { return _this.fetchData(response); })];
                }
            });
        }); };
        this.createPoll = function (question) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.getHttpClientPromise()];
                    case 1: return [2 /*return*/, (_a = (_b.sent())) === null || _a === void 0 ? void 0 : _a.post("/questions", {
                            question: question,
                        }, this.requestOptions).then(function (response) { return _this.fetchData(response); })];
                }
            });
        }); };
        this.updatePoll = function (question) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.getHttpClientPromise()];
                    case 1: return [2 /*return*/, (_a = (_b.sent())) === null || _a === void 0 ? void 0 : _a.patch("/questions/".concat(question.id), {
                            question: question,
                        }, this.requestOptions).then(function (response) { return _this.fetchData(response); })];
                }
            });
        }); };
        this.vote = function (pollId, optionId) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.getHttpClientPromise()];
                    case 1: return [2 /*return*/, (_a = (_b.sent())) === null || _a === void 0 ? void 0 : _a.post("/questions/".concat(pollId, "/vote"), {
                            optionId: optionId,
                        }, this.requestOptions).then(function (response) { return _this.fetchData(response); })];
                }
            });
        }); };
        this.unvote = function (pollId, optionId) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.getHttpClientPromise()];
                    case 1: return [2 /*return*/, (_a = (_b.sent())) === null || _a === void 0 ? void 0 : _a.post("/questions/".concat(pollId, "/unvote"), {
                            optionId: optionId,
                        }, this.requestOptions).then(function (response) { return _this.fetchData(response); })];
                }
            });
        }); };
        this.getVoters = function (pollId, optionId, params) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.getHttpClientPromise()];
                    case 1: return [2 /*return*/, (_a = (_b.sent())) === null || _a === void 0 ? void 0 : _a.get("/questions/".concat(pollId, "/options/").concat(optionId, "/voters"), __assign(__assign({}, this.requestOptions), { params: params })).then(function (response) { return _this.fetchData(response); })];
                }
            });
        }); };
        this.requestOptions = { baseURL: BASE_URL, headers: { Authorization: instance } };
    }
    return PollsService;
}());
export { PollsService };
//# sourceMappingURL=PollsService.js.map